import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryDocUploadList from "../screens/CategoryDocumentUpload/CategoryList";

const breadCrumbData = [{ link: "/category-document-upload-list", name: "Project List" }];
const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryDocUploadList />
    </LayoutContainer>
  </>
);

export default CategoryManagement;